<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-4 col-4">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("packings") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-8 col-8 text-right">
                    <base-button v-if="isAccessPayment"
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >ตัดรอบ Packing</base-button
                    >
					<!-- <base-button
                        size="md"
                        type="neutral"
                        @click="handleReturn()"
                        >สินค้าตีกลับ</base-button
                    > -->
					<!-- <base-button
                        size="md"
                        type="neutral"
                        @click="handleShipping()"
                        >ส่งสินค้า</base-button
                    > -->

					<base-button
                        size="md"
                        type="neutral"
                        @click="handleShippingWithCoupon()"
                        >ส่งสินค้าพร้อมคูปอง</base-button
                    >

					<base-button
                        size="md"
                        type="neutral"
                        @click="handleShippingWithCouponV3()"
                        >ส่งสินค้าพร้อมคูปอง (VDO)</base-button
                    >

					<base-button
                        size="md"
                        type="neutral"
                        @click="handleShippingByLine()"
                        >ส่งสินค้าตามสายแพ็ค</base-button
                    >

					<base-button v-if="isAccessPackingAdmin"
                        size="md"
                        type="neutral"
                        @click="handleShippingByLineAutoClose()"
                        >ส่งสินค้า (ปิดอัติโนมัติ)</base-button
                    >
					<base-button v-if="isAccessPackingAdmin"
                        size="md"
                        type="neutral"
                        @click="handleShippingAdmin()"
                        >ส่งสินค้า (Admin)</base-button
                    >
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2" >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" :config="{ allowInput: true }" :placeholder="$t('time_from')" class="form-control datepicker" v-model="params_search.time_from" > </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" :config="{ allowInput: true }" :placeholder="$t('time_to')" class="form-control datepicker" v-model="params_search.time_to" > </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select v-model="params_search.bo_sale_channel_type_id" :placeholder="$t('sale_channel_type')" filterable >
                                        <el-option v-for="option in SaleChannelTypeTableWithAll" :key="option.id" :label="option.name" :value="option.id" />
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select v-model="params_search.bo_payment_method_type_id" :placeholder="$t('payment_method_type')" filterable >
                                        <el-option v-for="option in PaymentMethodTypeTableWithAll" :key="option.id" :label="option.name" :value="option.id" />
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select v-model="params_search.shipping_provider_id" :placeholder="$t('shipping_provider')" filterable >
                                        <el-option v-for="option in ShippingProviderTableWithAll" :key="option.id" :label="option.name" :value="option.id" />
                                    </el-select>
                                </base-input>
                            </div>

								<div class="col-md-2">
									<base-input v-model="params_search.bo_packing_id" :placeholder="$t('packing_number')" />
								</div>
						</div>

						<div class="row">
								<div class="col-md-2">
									<base-button size="md"  @click="handleSearch()"> {{ $t("search") }}</base-button>
								</div>
							</div>
                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light" >

                            <!-- packing number -->
                            <el-table-column align="left" :label="$t('packing_number')" >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ID }} </span>
								</div>
                            </el-table-column>

							<!-- packing user -->
							<el-table-column align="left" :label="$t('packing_user')" >
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.Username }} </span>
								</div>
							</el-table-column>

							<!-- Order Count -->
							<el-table-column align="left" :label="$t('order_count')" >
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.OrderCount }} </span>
								</div>
							</el-table-column>


							<!-- Sale Channel -->
							<!-- <el-table-column align="left" :label="$t('sale_channel')" >
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.SaleChannelName }} </span>
								</div>
							</el-table-column> -->

							<!-- PaymentMethod -->
							<!-- <el-table-column align="left" :label="$t('payment_method')" >
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.PaymentMethodName != null ? row.PaymentMethodName : "-" }} </span>
								</div>
							</el-table-column> -->

							<!-- <el-table-column align="left" :label="$t('payment_method_type')" >
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.PaymentMethodTypeName != null ? row.PaymentMethodTypeName : "-" }} </span>
								</div>
							</el-table-column> -->

							<el-table-column align="left" :label="$t('detail')" min-width="300px">
								<div slot-scope="{ row }" class="d-flex">
									<span>
										{{ GetPackingName(row) }}
										 </span>
									<!-- Spec 2026-10-14 §5.3: round orders still without a tracking
									     number (no_tracking_count is additive — absent = no tag). -->
									<el-tag
										v-if="noTrackingOf(row) > 0"
										type="danger"
										size="small"
										class="ml-2 tf-badge"
										data-testid="packing-no-tracking"
										role="button"
										tabindex="0"
										@click.native="openFailures(row)"
										@keydown.enter.native="openFailures(row)"
									>{{ $t("tracking_failure.badge", { n: noTrackingOf(row) }) }}</el-tag>
								</div>
							</el-table-column>

							<!-- <el-table-column align="left" :label="$t('status')" >
								<div slot-scope="{ row }" class="d-flex">
									<span v-if="row.PackingStatusID == 0"> ไม่มี Tracking </span>
									<span v-if="row.PackingStatusID == 1"> กำลังขอ Tracking </span>
									<span v-if="row.PackingStatusID == 2"> Tracking ไม่สำเร็จ </span>
									<span v-if="row.PackingStatusID == 3"> Tracking สำเร็จ </span>
								</div>
							</el-table-column> -->

							<!-- date -->
							<el-table-column align="left" :label="$t('packing_date')" min-width="150px">
								<div slot-scope="{ row }" class="d-flex">
									<span> {{ row.CreatedAt }} </span>
                                </div>
							</el-table-column>

                            <el-table-column min-width="300px" align="right" :label="$t('actions')" >
                                <div slot-scope="{ $index, row }" class="d-flex" >
                                    <base-button @click.native=" handleDetail($index, row) " class="edit" type="warning" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-file"></i>
                                    </base-button>
									<base-button v-if="isSuperAdmin" :disabled="regenLoading" @click.native=" handleRegenTracking($index, row) " class="edit" type="info" size="sm" icon :title="$t('packing_regen_tracking')" >
                                        <i class="text-dtac-bt fa fa-truck"></i>
                                    </base-button>
									<!-- <base-button @click.native=" handleDownload($index, row,'A4') " class="edit" type="warning" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-download"></i> A4
                                    </base-button>
									<base-button @click.native=" handleDownload($index, row,'100x75') " class="edit" type="warning" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-download"></i> 100x75
                                    </base-button> -->
									<base-button @click.native=" handleDownload($index, row,'100x150') " class="edit" type="warning" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-download"></i> 100x150
                                    </base-button>
									<base-button @click.native=" handleDownloadXLSX($index, row) " class="edit" type="warning" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-download"></i> XLSX
                                    </base-button>
									<base-button @click.native=" handleDelete($index, row) " class="remove" type="danger" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>


		<modal :show.sync="showAddModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >
				<form class="new-event--form" @submit.prevent="saveEvent">
					<div class="row">
						<div class="col-md-12">
							<!-- sale channel -->
							<base-input :label="$t('sale_channel_type')" >
								<el-select v-model="params.bo_sale_channel_type_id">
									<el-option
										v-for="option in SaleChannelTypeTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- sale channel -->
							<base-input :label="$t('sale_channel')" >
								<el-select v-model="params.bo_sale_channel_id" >
									<el-option
										v-for="option in SaleChannelTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- sale channel -->
							<base-input :label="$t('payment_method_type')" >
								<el-select v-model="params.bo_payment_method_type_id" :placeholder="$t('payment_method_type')" filterable >
									<el-option
										v-for="option in PaymentMethodTypeTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- sale channel -->
							<base-input :label="$t('shipping_provider')" >
								<el-select v-model="params.shipping_provider_id" :placeholder="$t('shipping_provider')" filterable >
									<el-option
										v-for="option in ShippingProviderTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- sale channel -->
							<base-input :label="$t('packing_order_back_day')" >
								<el-select v-model="params.packing_order_back_day" :placeholder="$t('packing_order_back_day')" filterable >
									<el-option
										v-for="option in PackingOrderBackDayTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>

									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>
				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

		<tracking-failures-modal
			:visible.sync="failuresVisible"
			:bo-packing-id="failuresPackingId"
			mode="staff"
			@changed="listData(params_search)"
		></tracking-failures-modal>


    </div>
</template>
<script>
import { packingRoundErrorKey } from "@/utils/sellerPackingRound";
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import TrackingFailuresModal from "@/components/Packing/TrackingFailuresModal.vue";
import { noTrackingCount, regenSkippedBarcodeNotSaved } from "@/utils/trackingFailure";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Tag.name]: Tag,
        TrackingFailuresModal
    },
    computed: {
        ...mapGetters({
            tableData: "Packing/getData",
			SaleChannelTable: "SaleChannel/getData",
			PaymentMethodTable: "PaymentMethod/getData",
			PaymentMethodTypeTableWithAll:"PaymentMethod/getPaymentMethodTypeTableWithAll",
			isAccessPayment: "Auth/isAccessPayment",
			isAdmin: "Auth/isAdmin",
			isAccessPackingAdmin: "Auth/isAccessPackingAdmin",
			isSuperAdmin: "Auth/isSuperAdmin",
        }),
		PackingOrderBackDayTable(){
			return [
				{id:5,name:"5"},
				{id:10,name:"10"},
				{id:15,name:"15"},
			]
		},
		SaleChannelTableWithAll(){
			return [{id:0,name:"-- ช่องทางการขาย -- "}].concat(this.SaleChannelTable);
		},
		SaleChannelTypeTable(){
			return [
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			]
		},
		SaleChannelTypeTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการขาย -- "}].concat(this.SaleChannelTypeTable);
		},
		ShippingProviderTable(){
			return [
				{id:1,name:"ไปรษณีย์ไทย"},
				{id:2,name: "เคอรี่ เอ็กซ์เพรส"},
				// {id:3,name: "นินจาแวน"},
				// {id:4,name: "แฟลช เอ็กซ์เพรส"},
				{id:5,name: "DHL"},
				{id:6,name: "มาดามฟิน"},
				{id:7,name: "SPX"}
			]
		},
		ShippingProviderTableWithAll(){
			return [{id:0,name:"-- บริษัทขนส่ง -- "}].concat(this.ShippingProviderTable);
		},
		PaymentMethodTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการชำระเงิน -- "}].concat(this.PaymentMethodTable);
		},

    },
	mounted(){

		this.params_search.time_from = moment().add(-10, 'days').format('YYYY-MM-DD');
		this.params_search.time_to = moment().format('YYYY-MM-DD');
		if (this.$route.params.bo_packing_id != undefined) {
			this.params.bo_packing_id = this.$route.params.bo_packing_id
		}

		this.listSaleChannel();
		this.listData(this.params_search);
	},
    data() {
        return {
            propsToSearch: ["ID", "Username", "SaleChannelName","PaymentMethod"],
            regenLoading: false,
            failuresVisible: false,
            failuresPackingId: null,
            showAddModal: false,
            params: {
				bo_sale_channel_type_id:1,
				bo_sale_channel_id:0,
				bo_payment_method_type_id:1,
				shipping_provider_id:1,
				packing_order_back_day:5,
            },
            params_search: {
				time_from: "",
				time_to: "",
				bo_packing_id:"",
				bo_sale_channel_type_id:0,
				bo_payment_method_type_id:0,
				shipping_provider_id:0,
            }
        };
    },
    methods: {
        ...mapActions({
            createData: "Packing/createData",
            updateData: "Packing/updateData",
            deleteData: "Packing/deleteData",
            listData: "Packing/listData",
			listSaleChannel: "SaleChannel/listData",
			listPaymentMethod: "PaymentMethod/listData",
			getShippingDocument: "Packing/getShippingDocument",
			getShippingDocumentV2: "Packing/getShippingDocumentV2",
			listOrder: "Packing/listOrder",
			GenerateTracking: "Packing/GenerateTracking",
        }),
		noTrackingOf(row){
			return noTrackingCount(row) || 0;
		},
		openFailures(row){
			this.failuresPackingId = row.ID;
			this.failuresVisible = true;
		},
		GetPackingName(row){

			let PackingName = row.BoSaleChannelTypeName

			if (row.PaymentMethodTypeName != "") {
				PackingName += " - " + row.PaymentMethodTypeName
			}

			if (row.SaleChannelName != "") {
				PackingName += " - " + row.SaleChannelName
			}

			PackingName += " - " + row.ShippingProviderName

			return  PackingName

		},
		handleSearch(){
			this.listData(this.params_search);
		},
        handleCreate() {
			this.showAddModal = true
			// clear param
			this.params.bo_sale_channel_id = 0;
			this.params.bo_payment_method_id = 0;
        },
        handleUpdate() {
			if (this.params.bo_payment_method_type_id == 0) {
				swal.fire({
					title: this.$t("please_select_payment_method_type"),
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params.bo_sale_channel_type_id == 0) {
				swal.fire({
					title: this.$t("please_select_sale_channel_type"),
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params.shipping_provider_id == 0) {
				swal.fire({
					title: this.$t("please_select_shipping_provider_type"),
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			this.createData({
				bo_sale_channel_type_id : this.params.bo_sale_channel_type_id,
				bo_sale_channel_id : this.params.bo_sale_channel_id,
				shipping_provider_id : this.params.shipping_provider_id,
				bo_payment_method_type_id : this.params.bo_payment_method_type_id,
				packing_order_back_day: this.params.packing_order_back_day
			})
                    .then(resp => {
                        this.listData(this.params_search);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
						this.showAddModal = false;
                    })
                    .catch(err => {
                        swal.fire({
							title: this.$t(err.response.data.Msg),
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
						this.showAddModal = false;
                    });

        },
        handleDetail(index, row) {
				this.$router.push({ name: "BOOrders" ,params:{bo_packing_id:row.ID}});
        },
		async handleDownloadXLSX(index,row){

			// Get Order
			let resp = await this.listOrder({bo_packing_id:row.ID})
			console.log(resp)
			let i = 1

			let dataExport = resp.data.map((v) => {
				return {

				NO: i++,
				COMP_ORDER_ID: v.ID,
				INV_NO:v.ID,
				BARCODE_NO: '',
				PRODUCT_IN_BOX: 'น้ำหอม',
				RECEIVER : v.recipient_name,
				RECEIVER_ADDRESS: v.recipient_address_fulladdress,
				RECEIVER_AMPHUR: v.recipient_address_city,
				RECEIVER_PROVINCE: v.recipient_address_province,
				RECEIVER_ZIPCODE: v.recipient_zipcode,
				RECEIVER_TEL: v.recipient_phone,
				WEIGHT: 0,
				PRICE: v.amount,
				INSURE: '',
				INSURE_PRICE: '',
				STATUS: v.order_status,
				TRACKING:v.shipping_tracking_number,
				ADMIN_ID: v.bo_order_user_id,
				ADMIN_NAME: v.bo_order_user_name,

				}

			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_id_'+ row.ID+'.xlsx')

		},
		async handleDownload(index,row,pagesize){
			// swal show loading
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });
			this.getShippingDocumentV2({id:row.ID,pageSize:pagesize}).then(resp => {
				// url = api path
				swal.close();
				let url = process.env.VUE_APP_API_BASE_URL + "/files/packings/" + resp.data.Datum.url
				window.open(url, '_blank');
			}).catch(err => {
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
		},
        handleRegenTracking(index, row) {
            // Super-admin only: re-mint tracking numbers for orders in this packing
            // round that still have no tracking number. Shows the affected count.
            swal.fire({
                title: this.$t("packing_regen_tracking"),
                text: this.$t("packing_regen_tracking_confirm") + " #" + row.ID + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (!result.value) return;
                this.regenLoading = true;
                this.GenerateTracking({ bo_packing_id: row.ID }).then(resp => {
                    this.regenLoading = false;
                    const cnt = (resp && resp.data && resp.data.Datum != null) ? resp.data.Datum : 0;
                    // bo-api 099514b1: orders whose barcode was issued but not saved are skipped.
                    const skippedBns = regenSkippedBarcodeNotSaved(resp);
                    const regenSkipText = skippedBns > 0
                        ? " · " + this.$t("tracking_failure.skipped_barcode_not_saved", { n: skippedBns })
                        : "";
                    swal.fire({
                        title: this.$t("packing_regen_tracking_success"),
                        text: this.$t("packing_regen_tracking_result", { count: cnt }) + regenSkipText,
                        icon: "success",
                        confirmButtonClass: "btn btn-success btn-fill",
                        buttonsStyling: false
                    });
                }).catch(err => {
                    this.regenLoading = false;
                    // #845: the API answers {"Msg":"errors.tracking_in_progress"} (409)
                    // while another tracking pass holds this round — show that, not
                    // axios's "Request failed with status code 409".
                    const key = packingRoundErrorKey(err);
                    swal.fire({
                        title: key && this.$te(key) ? this.$t(key) : "Error",
                        text: key && this.$te(key) ? "" : ((err && err.message) || ""),
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
                });
            });
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.ID + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.ID)
                        .then(resp => {
                            this.listData(this.params_search);
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: "Error",
                                text: this.$t(err.response.data.Msg),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
		// handleShipping(){
		// 	this.$router.push({ name: "BOShipping" });
		// },
		handleShippingByLine(){
			this.$router.push({ name: "BOShippingLine" });
		},
		handleShippingByLineAutoClose(){
			this.$router.push({ name: "BOShippingLineAutoClose" });
		},
		handleShippingAdmin(){
			this.$router.push({ name: "BOShippingAdmin" });
		},
		handleReturn(){
			this.$router.push({ name: "BOShippingReturn" });
		},
		handleShippingWithCoupon(){
			this.$router.push({ name: "BOShippingCoupon" });
		},
		handleShippingWithCouponV3(){
			this.$router.push({ name: "BOShippingCouponV3" });
		}
    }
};
</script>
<style>
.tf-badge {
    cursor: pointer;
}
.no-border-card .card-footer {
    border-top: 0;
}
</style>
